module.exports = __webpack_public_path__ + "img/logo_recycled.740630d.svg";